module.exports = [
    {
        item:  "Не привязанные камеры",
        icon:  "videocam_off",
        route: "/not_provisioned_cameras",
        name:  "not_provisioned_cameras"
    },
    {
        item:  "Пользователи",
        icon:  "face",
        route: "/users",
        name:  "users"
    }
];
